var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x9B\xBE\xE5\xB1\x82_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_196643144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_194807272",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7422 2.88622V10.4767C3.7422 10.6521 3.81166 10.8027 3.93656 10.8986C4.06146 10.9944 4.20688 11.0083 4.34338 10.9376C6.49527 9.82335 8.61926 9.62906 10.6874 11.2718C12.4768 12.6929 14.9015 11.4369 17.1004 11.2861C17.3272 11.2706 17.5039 11.0504 17.5039 10.7834C17.5039 9.46658 17.5039 8.14973 17.5039 6.83302C17.5039 5.703 17.5039 4.57298 17.5039 3.44288C17.5039 3.25508 17.4232 3.09387 17.2836 3.0027C17.1439 2.91147 16.9849 2.91604 16.8492 3.01526C15.4653 4.02724 13.4568 3.9267 10.6543 2.39436C8.68828 1.31942 6.34143 2.26777 4.15144 2.38322C3.92245 2.39525 3.7422 2.61678 3.7422 2.88622Z",
    fill: "#DE350B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_196646360",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44141 1.25781C3.95696 1.25781 4.37883 1.68589 4.37883 2.19524V17.8147C4.37883 18.3241 3.95696 18.7521 3.44141 18.7521C2.92578 18.7521 2.50391 18.3303 2.50391 17.8147V2.19524C2.50391 1.67969 2.92578 1.25781 3.44141 1.25781Z",
    fill: "#DE350B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_196643144_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_194807272_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7422 2.88622V10.4767C3.7422 10.6521 3.81166 10.8027 3.93656 10.8986C4.06146 10.9944 4.20688 11.0083 4.34338 10.9376C6.49527 9.82335 8.61926 9.62906 10.6874 11.2718C12.4768 12.6929 14.9015 11.4369 17.1004 11.2861C17.3272 11.2706 17.5039 11.0504 17.5039 10.7834C17.5039 9.46658 17.5039 8.14973 17.5039 6.83302C17.5039 5.703 17.5039 4.57298 17.5039 3.44288C17.5039 3.25508 17.4232 3.09387 17.2836 3.0027C17.1439 2.91147 16.9849 2.91604 16.8492 3.01526C15.4653 4.02724 13.4568 3.9267 10.6543 2.39436C8.68828 1.31942 6.34143 2.26777 4.15144 2.38322C3.92245 2.39525 3.7422 2.61678 3.7422 2.88622Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_196646360_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44141 1.25781C3.95696 1.25781 4.37883 1.68589 4.37883 2.19524V17.8147C4.37883 18.3241 3.95696 18.7521 3.44141 18.7521C2.92578 18.7521 2.50391 18.3303 2.50391 17.8147V2.19524C2.50391 1.67969 2.92578 1.25781 3.44141 1.25781Z",
    fill: "#0C66E4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFlag);
export default __webpack_public_path__ + "static/media/blueFlag.4f762755b949cb8656155b33c7cf361a.svg";
export { ForwardRef as ReactComponent };